export class File {
  public name: string = '';
  public extension: string = '';
  public type: string = '';
  public size: number;
  public path: string = '';
  img: string;
  constructor() {
  }

  getExtension(): string {
    return this.extension;
  }

  setExtension(extension: string) {
    if (!extension) {
      extension = 'Unknown';
    }
    this.extension = extension;
  }

  setExtensionFromName(name: string) {
    let extension: string = '';
    if (name.lastIndexOf('.') > 0) {
      extension = name.substring(name.lastIndexOf('.') + 1);
    }
    if (!extension) {
      extension = 'Unknown';
    } else {
      extension = extension.toLowerCase();
    }
    this.extension = extension;
  }

  getName(): string {
    return this.name;
  }

  setName(name: string) {
    if (!name) {
      name = 'Unknown';
    }
    this.setExtensionFromName(name);
    this.name = name;
  }

  getType(): string {
    return this.type;
  }

  setType(type: string) {
    if (!type) {
      type = 'Unknown';
    }
    this.type = type;
  }

  getPath(): string {
    return this.path;
  }

  setPath(path: string) {
    this.path = path;
  }

  getSize(): number {
    return this.size;
  }

  setSize(size: number) {
    this.size = size;
  }
}
